import React, {
  useEffect, useState,
} from "react";
import { UserOptionsGroupTypes } from "./UserOptionsGroup.types";
import UserOptionBtn from "../UserOptionBtn/UserOptionBtnComponent";
import { Col, Row, Space } from "antd";
import NextStepBtnComponent from "../NextStepBtn/NextStepBtnComponent";
import BackBtnComponent from "../BackBtn/BackBtnComponent";

const UserOptionsGroup = ({ options }: UserOptionsGroupTypes) => {
  const [optionsState, setOptionsState] = useState(options);
  const [btnDisabled, setBtnDisabled] = useState(true);  
  const [userOptionText, setUserOptionText] = useState({text:'', value: 0});
  
  useEffect(() => {
    setOptionsState(
      options.map((element) => {
        element.disabled = false;
        return { ...element };
      })
    );
  }, [options]);

  const changeSelected = (item: any) => {
    setUserOptionText({text: item.currentTarget.title, value:item.currentTarget.value});
    setOptionsState(
      options.map((element) => {
        if (item.currentTarget.value == element.value) {
          element.disabled = true;
          setBtnDisabled(false);
        } else {
          element.disabled = false;
        }
        return { ...element };
      })
    );
    return null;
  };

  return (
    <>
      <Space size={22} direction="vertical">
        {optionsState.map((item, index) => (
          <div key={index}>
            <UserOptionBtn
              {...item}
              action={(e: any) => {
                changeSelected(e);
              }}
            />
          </div>
        ))}
        <Row justify="end" align="middle">
          <Col xs={{ order: 2, span: 24 }} sm={{ order: 1, span: 12 }}
          >
            <BackBtnComponent
              label={"Volver"}
              title="Volver atrás"
              classname="padding-md"
            ></BackBtnComponent>
          </Col>
          <Col xs={{ order: 1, span: 24 }} sm={{ order: 2, span: 12 }}>
            <NextStepBtnComponent
              id='simTrf-step0-transference-types'
              value={`/opciones/modalidad-transferencia`}
              text={"Iniciar simulación"}
              action={() => {}}
              disabled={btnDisabled}
              userOptionSelected={userOptionText}
            />
          </Col>
        </Row>
      </Space>
    </>
  );
};

export default UserOptionsGroup;
